/* global CKEDITOR */
(function() {
  'use strict';
  // No special characters method
  $.validator.addMethod('noSpecialChars', function(value, element) {
    return this.optional(element) || /^[a-z0-9\-]+$/i.test(value); // eslint-disable-line no-useless-escape
  }, 'Enter only letters, numbers or dashes');

  // No special characters method
  $.validator.addMethod('hexColor', function(value, element) {
    return this.optional(element) || /^#[a-f0-9]{6}$/i.test(value);
  }, 'Enter a 6-digit hex color, like #333333');

  // Add HTTP to URLs automatically
  $.validator.addMethod('complete_url', function(val, elem) {
    // if no url, don't do anything
    if (val.length === 0) { return true; }
    // if user has not entered http:// https:// or ftp:// assume they mean http://
    if (!/^(https?|ftp):\/\//i.test(val)) {
      // eslint-disable-next-line no-param-reassign
      val = 'http://' + val; // set both the value
      $(elem).val(val); // also update the form element
    }
    // now check if valid url
    // http://docs.jquery.com/Plugins/Validation/Methods/url
    // contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
    // eslint-disable-next-line no-useless-escape
    return (/^(https?|ftp):\/\/(((([a-z0-9]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&amp;'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&amp;'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&amp;'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&amp;'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&amp;'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(val));
  });

  // Check password
  $.validator.addMethod('pwcheck', function(value) {
    if (/^1+$|^123456$|^qwerty$|^abcdef$|^admin$|^password/.test(value)) { return false; }
    return true;
  });

  $.validator.addMethod('validApplyUrl', function(value, element) {
    // If you update this, also remember to update Quiz apply_url
    // eslint-disable-next-line no-useless-escape, no-mixed-operators
    return this.optional(element) || ! /https?:\/\/([^\/]*\.)?ziprecruiter\.com\//.test(value) && /^https?:\/\/(hire\.jobvite\.com\/j\/|[^\/]+\/.*[0-9])/.test(value);
  });

  $.validator.addMethod('ckeditorminlength', function(value, element, param) {
    var $el = $(element);
    CKEDITOR.instances[$el.attr('name')].updateElement();
    var val = $el.val();
    var isValid = jQuery(val).text().length >= param;
    if (!isValid) {
      $('html, body').animate({ scrollTop: $el.offset().top }, 100);
    }
    return isValid;
  }, jQuery.validator.format('Please enter at least {0} characters'));

  // Check phone number, based on current zr logic
  $.validator.addMethod('zrPhone', function(/* value */) {
    // if (!/^(\+\d+)|(1?\D*[2-9]\d{2}\D*\d{3}\D*\d{4}\D*)$/.test(value)) {return false;}
    return true;
  }, 'Invalid phone number format');
}());
